module.exports = __webpack_public_path__ + "img/kegiatan.3b4dee54.svg";